import React, { useState, useEffect } from 'react';
import styled from 'styled-components'
import { Link } from 'react-scroll';

const Ul = styled.ul`

    list-style: none;
    display: flex;
    flex-flow: row nowrap;
    color: #ffffff;

    li {
        padding: 15px 15px;
        cursor: pointer;
        /* margin-left: 50px; */
    }

    @media (max-width: 768px) {
        flex-flow: column nowrap;
        background-color: #1F252A;
        position: fixed;
        transform: ${({ open }) => open ? 'translateX(0)' : 'translateX(100%)'};
        top: -16px !important;
        right: 0;
        height: 100vh;
        width: 100%;
        padding-top: 100px;
        padding-left: 50px;
        transition: transform 0.3s ease-in-out;

        li {
            /* color: white; */
            font-size: 24px;
            font-weight: bolder;
            /* margin-left: 50px !important; */
            text-align: center;
        }

        a {
          margin: 0 auto;
        }
        .lang {
          margin-top: 20px;
        }
    }

`

const RightNav = ({ open, setOpen }) => {

    // language toggler function
    const [currentLanguage, setCurrentLanguage] = useState('en');
    const translations = require(`../../translations/${currentLanguage}.json`);
    console.log("RIGHT NAV CURRENT DATA", currentLanguage)

    const setLang = lang => {
        window.localStorage.setItem('language', lang);
        setCurrentLanguage(lang);
    }
    const langToggler = () => {
        currentLanguage === 'en' ? setLang('jp') : setLang('en');
    }
    useEffect(() => {
        const localLanguage = window.localStorage.getItem('language')
        localLanguage ? setCurrentLanguage(localLanguage) : setLang('en')
      }, [])

    const handleRefreshClick = () => {
    window.location.reload(); // Reload the page
    }

    return (
        <Ul open={open} setOpen={setOpen}>
            <Link 
            activeClass="active"
            onClick={() => setOpen(!open)}
            to="home"
            spy={true} 
            smooth={true}
            offset={-70}>
                <li>{translations.home}</li>
            </Link>
            <Link
            activeClass="active" 
            onClick={() => setOpen(!open)}
            to="about"
            spy={true} 
            smooth={true}
            offset={-70}>
                <li>{translations.about}</li>
            </Link>
            <Link
            activeClass="active" 
            onClick={() => setOpen(!open)}
            to="products"
            spy={true} 
            smooth={true}
            offset={-70}>
                <li>{translations.products}</li>
            </Link>
            <Link
            activeClass="active" 
            onClick={() => setOpen(!open)}
            to="contact"
            spy={true} 
            smooth={true}
            offset={-70}>
                <li>{translations.contact}</li>
            </Link>
            <a>
              <button className='lang' type="submit" onClick={() => {
                langToggler();
                handleRefreshClick();
              }}>
                <span class="material-symbols-outlined">
                language
                </span>
                <span className='switch'>
                {currentLanguage === 'en' ? '日本語 ' : 'English'}
                </span>
              </button>
            </a>
        </Ul>
    )
}

export default RightNav
